// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/components/NotFoundPage/index.js"
);
import.meta.hot.lastModified = "1692612803116.515";
}
// REMIX HMR END

export { NotFoundPage } from "./NotFoundPage";
